import { render, staticRenderFns } from "./PaginaAdminSeleccionPreguntasMuni.vue?vue&type=template&id=78f8999c&lang=true"
import script from "./PaginaAdminSeleccionPreguntasMuni.vue?vue&type=script&lang=js"
export * from "./PaginaAdminSeleccionPreguntasMuni.vue?vue&type=script&lang=js"
import style0 from "./PaginaAdminSeleccionPreguntasMuni.vue?vue&type=style&index=0&id=78f8999c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports